import { createSlice, createSelector } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";

const slice = createSlice({
  name: "documents",
  initialState: {
    list: [],
    loading: false,
    lastFetch: null,
    docDownloadData: null,
  },
  reducers: {
    documentDownloaded: (documents, action) => {
      documents.docDownloadData = action.payload;
    },
  },
});

export const { documentDownloaded } = slice.actions;
export default slice.reducer;

const downloadAppDoc = "WfApplication/DownloadAppDoc?id=";

export const downloadDocument = (id, clientId) =>
  apiCallBegan({
    url: downloadAppDoc + id + "&clientId=" + clientId,
    //responseType: "blob",
    onSuccess: documentDownloaded.type,
  });

export const getDownloadedDocumentData = createSelector(
  (state) => state.entities.documents,
  (documents) => documents.docDownloadData,
);
